import Config from "config/config"
import Web3 from "web3"

export const web3 = new Web3(Config.ETHEREUM?.provider)

export default function useWeb3() {
  return web3
}
